// src/components/Board.jsx
// Three-column severity board. Mobile collapses to a single stacked feed
// (driven by CSS media query in tokens; this component renders all three
// columns and the grid handles the layout).
//
// CLAUDE CODE: prepend `import React from "react";` etc, replace
// the `const PPIcons = window.PPIcons; ...` lines with real imports,
// and add `export default X;` at the bottom (replacing `window.X = X`).

import React from "react";
import SeverityColumn from "./SeverityColumn";

function Board({
  posts,
  currentUid, isAdmin, orgId, categories,
  onUpvote, onDelete, onReport, onSmartTask, onUpdateStatus,
  loading,
}) {
  const buckets = {
    critical: posts.filter(p => p.severity === "critical"),
    moderate: posts.filter(p => p.severity === "moderate"),
    low:      posts.filter(p => p.severity === "low" || !["critical", "moderate"].includes(p.severity)),
  };

  return (
    <div className="pp-board">
      <SeverityColumn
        severity="critical" label="Critical"
        posts={buckets.critical}
        currentUid={currentUid} isAdmin={isAdmin}
        onUpvote={onUpvote} onSmartTask={onSmartTask}
        onUpdateStatus={onUpdateStatus} onReport={onReport} onDelete={onDelete}
        loading={loading}
      />
      <SeverityColumn
        severity="moderate" label="Moderate"
        posts={buckets.moderate}
        currentUid={currentUid} isAdmin={isAdmin}
        onUpvote={onUpvote} onSmartTask={onSmartTask}
        onUpdateStatus={onUpdateStatus} onReport={onReport} onDelete={onDelete}
        loading={loading}
      />
      <SeverityColumn
        severity="low" label="Low"
        posts={buckets.low}
        currentUid={currentUid} isAdmin={isAdmin}
        onUpvote={onUpvote} onSmartTask={onSmartTask}
        onUpdateStatus={onUpdateStatus} onReport={onReport} onDelete={onDelete}
        loading={loading}
      />
    </div>
  );
}

export default Board;
